import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/enviroments';
import { InvoiceDto } from '../interfaces/InvoiceDto';

@Injectable({
  providedIn: 'root'
})
export class OpportunitiesService {

  constructor(private http: HttpClient) { }
  public getAllOpportunities(
    days: number=1,
    endDate: string=null,
    // start: any,
    // end: any,
    // page: number,
    // search: string,
    // size: number,
    // sii: boolean | null,
    // isPyme,
    // sortOrder: string
  ) {
    // const pymeQuery = isPyme != null ? `&isPyme=${isPyme}` : '';
    const endpoint = `${environment.apiUrl}/Invoice/Opportunities?days=${days}&endDate=${endDate}`;
    return this.http.get<any>(endpoint);
  }
}
